export default __webpack_public_path__ + "static/media/faf-special-edition.741d18a9.png";